"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceShareAccessView = void 0;
var _react = require("react");
var _materialSymbols = require("@design/icons/material-symbols");
var _modalBXsU9PJPGdHkA5xZcxCesE = require("@design-generated/modal-bXsU9PJPGdHkA5xZcxCesE-1991-130027");
var _modalBXsU9PJPGdHkA5xZcxCesE2 = require("@design-generated/modal-bXsU9PJPGdHkA5xZcxCesE-1991-130027.wiring");
var _modalBXsU9PJPGdHkA5xZcxCesE3 = require("@design-generated/modal-bXsU9PJPGdHkA5xZcxCesE-1997-133026");
var _modalBXsU9PJPGdHkA5xZcxCesE4 = require("@design-generated/modal-bXsU9PJPGdHkA5xZcxCesE-1997-133026.wiring");
var _avatar = require("@design/ui/avatar");
var _badge = require("@design/ui/badge");
var _button = require("@design/ui/button");
var _command = require("@design/ui/command");
var _inputGroup = require("@design/ui/input-group");
var _item = require("@design/ui/item");
var _popover = require("@design/ui/popover");
var _switch = require("@design/ui/switch");
var _utils = require("@design/lib/utils");
var _portalLayer = require("@common/components/share/portal-layer");
var _resourceShareCopy = require("./resource-share-copy");
var _shareMenuClasses = require("./share-menu-classes");
var _shareGranteeAvatar = require("./share-grantee-avatar");
var _shareRoleSelect = require("./share-role-select");
var _shareConfirmationBanner = require("./share-confirmation-banner");
var _shareCopyLinkButton = require("./share-copy-link-button");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FIELD_LABEL_CLASS = "text-sm font-medium text-foreground-secondary";
var ResourceShareAccessView = exports.ResourceShareAccessView = function ResourceShareAccessView(_ref) {
  var resourceName = _ref.resourceName,
    resourceKind = _ref.resourceKind,
    currentUser = _ref.currentUser,
    grantees = _ref.grantees,
    isLoading = _ref.isLoading,
    canManageShares = _ref.canManageShares,
    query = _ref.query,
    searchResults = _ref.searchResults,
    invitableTeams = _ref.invitableTeams,
    isSearching = _ref.isSearching,
    error = _ref.error,
    confirmation = _ref.confirmation,
    invitees = _ref.invitees,
    inviteRole = _ref.inviteRole,
    isInviting = _ref.isInviting,
    viewerOnly = _ref.viewerOnly,
    copyLink = _ref.copyLink,
    onQueryChange = _ref.onQueryChange,
    onAddInvitee = _ref.onAddInvitee,
    onRemoveInvitee = _ref.onRemoveInvitee,
    onInviteRoleChange = _ref.onInviteRoleChange,
    onCancelInvite = _ref.onCancelInvite,
    onSendInvites = _ref.onSendInvites,
    onShowCollaborators = _ref.onShowCollaborators,
    onTeamPickerOpen = _ref.onTeamPickerOpen,
    closeIcon = _ref.closeIcon;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTeamMenuOpen = _useState2[0],
    setIsTeamMenuOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    copyLinkError = _useState4[0],
    setCopyLinkError = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    areSearchResultsDismissed = _useState6[0],
    setAreSearchResultsDismissed = _useState6[1];
  var individualFieldRef = (0, _react.useRef)(null);
  var displayedError = error !== null && error !== void 0 ? error : copyLinkError;
  function changeTeamMenuOpen(isOpen) {
    setIsTeamMenuOpen(isOpen);
    if (isOpen) onTeamPickerOpen();
  }
  var teamLabelId = (0, _react.useId)();
  var teamSummaryId = (0, _react.useId)();
  var isInviteDraft = invitees.length > 0;
  var invitedPeople = invitees.filter(function (invitee) {
    return invitee.kind === "user";
  });
  var invitedTeams = invitees.flatMap(function (invitee) {
    return invitee.kind === "team" ? [invitee.team] : [];
  });
  var invitedTeamIds = new Set(invitedTeams.map(function (team) {
    return team.teamId;
  }));
  var headerContent = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "self-stretch text-base font-medium text-foreground-primary",
      children: (0, _resourceShareCopy.shareDialogTitle)(resourceName)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "self-stretch text-sm text-foreground-muted",
      children: (0, _resourceShareCopy.shareDialogDescription)(resourceKind)
    })]
  });
  function renderSearchResult(grantee) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.CommandItem, {
      value: (0, _resourceShareCopy.granteeKey)(grantee),
      onSelect: function onSelect() {
        return onAddInvitee(grantee);
      },
      "data-sentry-element": "CommandItem",
      "data-sentry-component": "renderSearchResult",
      "data-sentry-source-file": "resource-share-access-view.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemMedia, {
        "data-sentry-element": "ItemMedia",
        "data-sentry-source-file": "resource-share-access-view.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shareGranteeAvatar.ShareGranteeAvatar, {
          grantee: grantee,
          size: "default",
          "data-sentry-element": "ShareGranteeAvatar",
          "data-sentry-source-file": "resource-share-access-view.tsx"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.ItemContent, {
        className: "min-w-0",
        "data-sentry-element": "ItemContent",
        "data-sentry-source-file": "resource-share-access-view.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemTitle, {
          "data-sentry-element": "ItemTitle",
          "data-sentry-source-file": "resource-share-access-view.tsx",
          children: (0, _resourceShareCopy.granteeName)(grantee)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemDescription, {
          className: "truncate",
          "data-sentry-element": "ItemDescription",
          "data-sentry-source-file": "resource-share-access-view.tsx",
          children: (0, _resourceShareCopy.granteeDetail)(grantee)
        })]
      })]
    }, (0, _resourceShareCopy.granteeKey)(grantee));
  }
  var isSearchResultsMenuOpen = query.trim().length > 0 && !(isSearching && searchResults.length === 0) && !areSearchResultsDismissed;
  function renderSearchResultsMenu() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverContent, _objectSpread(_objectSpread({}, _portalLayer.PORTAL_LAYER_PROPS), {}, {
      align: "start",
      onOpenAutoFocus: function onOpenAutoFocus(event) {
        return event.preventDefault();
      },
      onInteractOutside: function onInteractOutside(event) {
        var _individualFieldRef$c;
        return ((_individualFieldRef$c = individualFieldRef.current) === null || _individualFieldRef$c === void 0 ? void 0 : _individualFieldRef$c.contains(event.target)) && event.preventDefault();
      },
      className: (0, _utils.cn)("w-(--radix-popover-trigger-width) gap-0", _shareMenuClasses.SHARE_MENU_CONTENT_CLASS),
      "data-sentry-element": "PopoverContent",
      "data-sentry-component": "renderSearchResultsMenu",
      "data-sentry-source-file": "resource-share-access-view.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.CommandList, {
        className: "max-h-60",
        "data-sentry-element": "CommandList",
        "data-sentry-source-file": "resource-share-access-view.tsx",
        children: [searchResults.map(renderSearchResult), /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandEmpty, {
          className: "px-4 py-2 text-left text-foreground-muted",
          "data-sentry-element": "CommandEmpty",
          "data-sentry-source-file": "resource-share-access-view.tsx",
          children: "No matching people"
        })]
      })
    }));
  }
  function renderInvitee(grantee) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_badge.Badge, {
      className: "h-8 gap-2 rounded-lg bg-background-canvas px-2 text-sm font-normal text-foreground-primary",
      "data-sentry-element": "Badge",
      "data-sentry-component": "renderInvitee",
      "data-sentry-source-file": "resource-share-access-view.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_shareGranteeAvatar.ShareGranteeAvatar, {
        grantee: grantee,
        size: "sm",
        "data-sentry-element": "ShareGranteeAvatar",
        "data-sentry-source-file": "resource-share-access-view.tsx"
      }), (0, _resourceShareCopy.granteeName)(grantee), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
        type: "button",
        variant: "ghost",
        size: "icon-xs",
        disabled: isInviting,
        "aria-label": "Remove ".concat((0, _resourceShareCopy.granteeName)(grantee)),
        onClick: function onClick() {
          return onRemoveInvitee(grantee);
        },
        "data-sentry-element": "Button",
        "data-sentry-source-file": "resource-share-access-view.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {
          "data-sentry-element": "CloseIcon",
          "data-sentry-source-file": "resource-share-access-view.tsx"
        })
      })]
    }, (0, _resourceShareCopy.granteeKey)(grantee));
  }
  var draftRoleSelect = viewerOnly ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "self-center px-3 text-sm text-foreground-muted",
    children: "Viewer"
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_shareRoleSelect.ShareRoleSelect, {
    role: inviteRole,
    resourceKind: resourceKind,
    disabled: isInviting,
    ariaLabel: "Permission for invited people and teams",
    onRoleChange: onInviteRoleChange,
    onRemoveCollaborator: undefined
  });
  var inviteRoleSelect = isInviteDraft ? draftRoleSelect : null;
  var confirmationBanner = confirmation && !query.trim() ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "absolute top-full right-0 left-0 z-10",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shareConfirmationBanner.ShareConfirmationBanner, {
      message: confirmation
    })
  }) : null;
  var individualField = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2 self-stretch",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: FIELD_LABEL_CLASS,
      children: "Invite an individual"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "relative self-stretch",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.Popover, {
        open: isSearchResultsMenuOpen,
        onOpenChange: function onOpenChange(isOpen) {
          return isOpen || setAreSearchResultsDismissed(true);
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverAnchor, {
          asChild: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_inputGroup.InputGroup, {
            ref: individualFieldRef,
            className: "h-auto items-start gap-2.5 p-1",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "flex min-w-0 flex-1 flex-wrap items-center gap-1",
              children: [invitedPeople.map(renderInvitee), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_command.Command, {
                shouldFilter: false,
                label: "Enter name or email",
                className: "contents",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandComboboxInput, {
                  value: query,
                  onValueChange: function onValueChange(nextQuery) {
                    setAreSearchResultsDismissed(false);
                    onQueryChange(nextQuery);
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupInput, {
                    autoFocus: true,
                    "aria-expanded": isSearchResultsMenuOpen,
                    onClick: function onClick() {
                      return setAreSearchResultsDismissed(false);
                    },
                    placeholder: invitedPeople.length > 0 ? "Add more" : "Enter name or email",
                    className: "min-w-24"
                  })
                }), renderSearchResultsMenu()]
              })]
            }), inviteRoleSelect]
          })
        })
      }), confirmationBanner]
    })]
  });
  function renderTeamOption(team) {
    var grantee = (0, _resourceShareCopy.teamGrantee)(team);
    var isInvited = invitedTeamIds.has(team.teamId);
    var detail = isInvited ? (0, _resourceShareCopy.teamInviteDetail)(team, inviteRole) : (0, _resourceShareCopy.granteeDetail)(grantee);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.Item, {
      size: "sm",
      asChild: true,
      "data-sentry-element": "Item",
      "data-sentry-component": "renderTeamOption",
      "data-sentry-source-file": "resource-share-access-view.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
        className: "cursor-pointer hover:bg-muted",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemMedia, {
          "data-sentry-element": "ItemMedia",
          "data-sentry-source-file": "resource-share-access-view.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shareGranteeAvatar.ShareGranteeAvatar, {
            grantee: grantee,
            size: "default",
            "data-sentry-element": "ShareGranteeAvatar",
            "data-sentry-source-file": "resource-share-access-view.tsx"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.ItemContent, {
          className: "min-w-0",
          "data-sentry-element": "ItemContent",
          "data-sentry-source-file": "resource-share-access-view.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemTitle, {
            "data-sentry-element": "ItemTitle",
            "data-sentry-source-file": "resource-share-access-view.tsx",
            children: team.name
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemDescription, {
            className: "truncate",
            "data-sentry-element": "ItemDescription",
            "data-sentry-source-file": "resource-share-access-view.tsx",
            children: detail
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemActions, {
          "data-sentry-element": "ItemActions",
          "data-sentry-source-file": "resource-share-access-view.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_switch.Switch, {
            checked: isInvited,
            disabled: isInviting,
            "aria-label": "Invite ".concat(team.name),
            onCheckedChange: function onCheckedChange() {
              return isInvited ? onRemoveInvitee(grantee) : onAddInvitee(grantee);
            },
            "data-sentry-element": "Switch",
            "data-sentry-source-file": "resource-share-access-view.tsx"
          })
        })]
      })
    }, team.teamId);
  }
  var hasInvitedTeams = invitedTeams.length > 0;
  var teamTriggerLabel = /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    id: teamSummaryId,
    className: (0, _utils.cn)("min-w-0 flex-1 truncate", hasInvitedTeams ? "text-foreground-primary" : "text-foreground-muted"),
    children: hasInvitedTeams ? (0, _resourceShareCopy.selectedTeamsSummary)(invitedTeams) : "Select team(s)"
  });
  var teamField = invitableTeams.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2 self-stretch",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      id: teamLabelId,
      className: FIELD_LABEL_CLASS,
      children: "Invite a team"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_popover.Popover, {
      open: isTeamMenuOpen,
      onOpenChange: changeTeamMenuOpen,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverTrigger, {
        asChild: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
          variant: "outline",
          disabled: isInviting,
          "aria-labelledby": "".concat(teamLabelId, " ").concat(teamSummaryId),
          className: "w-full justify-between font-normal",
          children: [teamTriggerLabel, /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
            "data-icon": "inline-end",
            className: "text-foreground-muted"
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverContent, _objectSpread(_objectSpread({}, _portalLayer.PORTAL_LAYER_PROPS), {}, {
        align: "start",
        className: (0, _utils.cn)("z-floating max-h-80 w-(--radix-popover-trigger-width) gap-0 overflow-y-auto", _shareMenuClasses.SHARE_MENU_CONTENT_CLASS),
        children: invitableTeams.map(renderTeamOption)
      }))]
    })]
  }) : null;
  var inviteFields = canManageShares ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-4 self-stretch",
    children: [individualField, teamField]
  }) : null;
  var errorMessage = displayedError ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "text-sm text-destructive-text",
    children: displayedError
  }) : null;
  var copyLinkButton = copyLink ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_shareCopyLinkButton.ShareCopyLinkButton, {
    copyLink: copyLink,
    onCopyErrorChange: setCopyLinkError
  }) : null;
  var granteesSummary = /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "flex-1 text-sm text-foreground-primary",
    children: (0, _resourceShareCopy.granteesWithAccessSummary)(grantees, currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId)
  });
  var isSharedWithOthers = grantees.some(function (grantee) {
    return grantee.kind === "team" || grantee.user.userId !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId);
  });
  var granteeAvatars = /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarGroup, {
    children: grantees.slice(0, _resourceShareCopy.GRANTEES_SHOWN_AS_AVATARS).map(function (grantee) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_shareGranteeAvatar.ShareGranteeAvatar, {
        grantee: grantee,
        size: "default"
      }, (0, _resourceShareCopy.granteeKey)(grantee));
    })
  });
  var granteesValue = isSharedWithOthers ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.Item, {
    size: "xs",
    asChild: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      type: "button",
      "aria-label": "Show everyone with access",
      onClick: onShowCollaborators,
      children: [granteeAvatars, granteesSummary, /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemActions, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
          className: "text-foreground-muted"
        })
      })]
    })
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.Item, {
    size: "xs",
    children: [granteeAvatars, granteesSummary]
  });
  var accessSection = isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "text-sm text-foreground-muted",
    children: "Loading\u2026"
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2 self-stretch",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: FIELD_LABEL_CLASS,
      children: "Who has access"
    }), granteesValue]
  });
  var modalContent = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [inviteFields, accessSection, copyLinkButton, errorMessage]
  });
  if (isInviteDraft) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_modalBXsU9PJPGdHkA5xZcxCesE4.ModalBXsU9PJPGdHkA5xZcxCesE1997133026Context.Provider, {
      value: {
        modalHeaderContent: headerContent,
        close: closeIcon,
        modalContent: modalContent,
        button: {
          onClick: onCancelInvite,
          disabled: isInviting
        },
        button2: {
          onClick: onSendInvites,
          disabled: isInviting
        }
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_modalBXsU9PJPGdHkA5xZcxCesE3.ModalBXsU9PJPGdHkA5xZcxCesE1997133026Screen, {})
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_modalBXsU9PJPGdHkA5xZcxCesE2.ModalBXsU9PJPGdHkA5xZcxCesE1991130027Context.Provider, {
    value: {
      modalHeaderContent: headerContent,
      close: closeIcon,
      modalContent: modalContent
    },
    "data-sentry-element": "ShareAccessContext.Provider",
    "data-sentry-component": "ResourceShareAccessView",
    "data-sentry-source-file": "resource-share-access-view.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_modalBXsU9PJPGdHkA5xZcxCesE.ModalBXsU9PJPGdHkA5xZcxCesE1991130027Screen, {
      "data-sentry-element": "ShareAccessScreen",
      "data-sentry-source-file": "resource-share-access-view.tsx"
    })
  });
};